import { Alert, Text } from "@mantine/core";

export const QaResultBanner = ({ result }: { result: any }) => {
  const getResultValue = () => {
    if (result.entity_id === "NOT_FOUND") {
      return "Not an Item";
    } else if (result.skip) {
      return "Skipped";
    } else {
      return null;
    }
  };

  const resultValue = getResultValue();
  if (!resultValue) {
    return null;
  }
  return (
    <Alert variant="light" color="yellow" style={{ padding: 5 }}>
      Result: <Text fw={600}>{resultValue}</Text>
    </Alert>
  );
};
